export default {
  emptyStateHeader: 'No teammates added',
  emptyStateText: "Add some teammates to your account by tapping 'Add User'",
};
